import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Link} from 'react-router-dom';
import { Menu, Row, Col, Icon, Card, Form } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import PersonalDetails from './PersonalDetails';
import Vehicles from './Vehicles';
import Payments from './Payments';
import Payouts from './Payouts';
import Password from './Password';
import IDVerification from './IDVerification';


const { SubMenu } = Menu;


class PersonalDetailsForm extends Component {
    callback(key) {
        console.log(key);
    }

    showDescriptionModal = () => { }

    handleClick = e => {
        console.log('click ', e);
    };

    handleSubmit() {
        console.log('submit button clicked')
    }

    render() {


        return (
            <div>
                <br />
                <Row type="flex">
                    <Col md={{ span: 5, offset: 3 }}>
                        <Menu
                            onClick={this.handleClick}
                            style={{ width: 256 }}
                            defaultSelectedKeys={['1']}
                            defaultOpenKeys={['sub1']}
                            mode="inline"
                        >
                            <SubMenu
                                key="sub1"
                                title={
                                    <span>
                                        <Icon type="user" />
                                        <span style={{ fontWeight: "bold" }}>Profile</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="1">
                                    <Link to="/account">
                                         Personal details
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="2">
                                    <Link to="/account/vehicles">
                                         Vehicles
                                    </Link>
                                </Menu.Item>
                            </SubMenu>
                            <SubMenu
                                key="sub2"
                                title={
                                    <span>
                                        <Icon type="dollar" />
                                        <span style={{ fontWeight: "bold" }}>Money</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="3">
                                    <Link to="/account/payments">
                                         Payments
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="4">
                                    <Link to="/account/payouts">
                                         Payouts
                                    </Link>
                                </Menu.Item>
                            </SubMenu>
                            <SubMenu
                                key="sub3"
                                title={
                                    <span>
                                        <Icon type="lock" />
                                        <span style={{ fontWeight: "bold" }}>Security</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="5">
                                    <Link to="/account/password">
                                         Password
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="6">
                                    <Link to="/account/idverification">
                                         ID Verification
                                    </Link>
                                </Menu.Item>
                            </SubMenu>

                        </Menu>
                    </Col>
                    <Col md={{ span: 13 }}>
                        <Card>
                            <Switch>
                                <Route path="/account" exact component={PersonalDetails} />
                                <Route path="/account/vehicles" exact component={Vehicles} />
                                <Route path="/account/payments" exact component={Payments} />
                                <Route path="/account/payouts" exact component={Payouts} />
                                <Route path="/account/password" exact component={Password} />
                                <Route path="/account/idverification" exact component={IDVerification} />
                            </Switch>
                        </Card>
                    </Col>
                </Row>

            </div>
        );
    }


}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.token !== null
    }
}

const Account = Form.create({ name: 'personal-details-form' })(PersonalDetailsForm);

export default connect(mapStateToProps, null)(Account);



// export default Account;
